import React from 'react';
import { createPortal } from 'react-dom';
import FormularioEndoso from '../Formularios/FormularioEndoso';

const ModalEndoso = ({ show, onClose, onSuccess, poliza, clientData, initialData }) => {
  if (!show) return null;

  const title = initialData ? 'Editar Endoso' : 'Cargar Nuevo Endoso';

  // Wrapper para manejar el éxito y cerrar el modal automáticamente
  const handleSuccess = (msg, type) => {
    onSuccess(msg, type);
    onClose();
  };

  return createPortal(
    <div className="fixed inset-0 bg-gray-900 bg-opacity-60 z-[1010] flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl flex flex-col overflow-hidden animate-fade-in max-h-[90vh]">
        
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 bg-blue-50/50 shrink-0">
            <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                <span className="bg-blue-100 text-blue-600 p-1.5 rounded-lg">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                </span>
                {title}
            </h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-white">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
        </div>

        {/* Body Scrollable */}
        <div className="overflow-y-auto p-6 bg-white custom-scrollbar">
            <FormularioEndoso 
                poliza={poliza}
                clientData={clientData}
                initialData={initialData}
                onSuccess={handleSuccess}
                onCancel={onClose}
            />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ModalEndoso;